import React, { type ComponentType } from 'react';

import {
	JQLEditorAsync as JqlEditorAsyncUsingLegacyReactLooselyLazy,
	JQLEditorReadOnly,
	type JQLEditorUIProps,
} from '@atlaskit/jql-editor';

import { lazyForPaint, LazySuspense } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { JQLBuilderAdvancedProps } from './types.tsx';
import JQLBuilderAdvancedUI from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const JQLEditor = lazyForPaint<ComponentType<JQLEditorUIProps>>(
	() =>
		import(/* webpackChunkName: "async-jql-editor" */ '@atlaskit/jql-editor').then(
			(module) => module.JQLEditor,
		),
	{ ssr: false },
);

export const preloadJQLEditor = () => JQLEditor.preload();

export const JQLEditorAsync = (props: JQLEditorUIProps) => {
	const fallback = (
		<JQLEditorReadOnly
			query={props.query}
			isSearch={!!props.onSearch}
			isCompact={props.isCompact}
		/>
	);
	return (
		<JSErrorBoundary
			id="jqlEditorAsync"
			teamName="Empanada"
			packageName="jiraJqlBuilderAdvanced"
			fallback={() => fallback}
			onError={(_location, error) => props.onRenderError?.(error)}
		>
			<LazySuspense fallback={fallback}>
				<JQLEditor {...props} />
			</LazySuspense>
		</JSErrorBoundary>
	);
};

const JQLBuilderAdvancedAsync = (props: JQLBuilderAdvancedProps): React.JSX.Element => (
	<JQLBuilderAdvancedUI
		{...props}
		JQLEditor={
			fg('jfp-magma-nin-hydration-fixes')
				? JQLEditorAsync
				: JqlEditorAsyncUsingLegacyReactLooselyLazy
		}
	/>
);

export default JQLBuilderAdvancedAsync;
